import AdminApi from '../../services/api'
import Loc from "../../services/localization";
import swal from "sweetalert2";
import session from "../../services/session";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            isLoading: false,
            isLoadingSave: false,
            editBalance: false,
            fromDate: new Date(),
            toDate: new Date(),
            schedules: [],
            filterSchedules: [
                {
                    id: 1,
                    label: LocService.t('label_type_active')
                },
                {
                    id: 2,
                    label: LocService.t('label_type_closed')
                },
                {
                    id: 3,
                    label: LocService.t('label_type_approved')
                }
            ],
            filterScheduleItems: [
                {
                    id: 1,
                    label: LocService.t('label_si_all')
                },
                {
                    id: 2,
                    label: LocService.t('label_si_sell')
                },
                {
                    id: 3,
                    label: LocService.t('label_si_buy')
                },
                {
                    id: 4,
                    label: LocService.t('label_si_purchase')
                },
                {
                    id: 5,
                    label: LocService.t('label_si_additional_cost')
                }
            ],
            schedulesNames: [],
            selectedFilter: 1,
            selectedShiftName: "",
            currentEur: 0,
            currentRsd: 0,
            newEur: 0,
            newRsd: 0,
            newScheduleEur: 0,
            newScheduleRsd: 0,
            role: '',
            scheduleToClose: null,
            scheduleItemToEdit: null,
            scheduleToEdit: null,
            additionalCostItem: null,
        };
    },
    computed: {
        filteredSchedules() {
            let _self = this;
            let filteredShiftSchedule = this.selectedShiftName === '' ? this.schedules : this.schedules.filter(s => s.schedule.firstName === this.selectedShiftName);
            if(_self.selectedFilter === 1){
                return filteredShiftSchedule.filter((item) => {
                    return item.schedule.state === 'ACTIVE'
                });
            }
            if(_self.selectedFilter === 2){
                return filteredShiftSchedule.filter((item) => {
                    return item.schedule.state === 'CLOSED'
                });
            }

            if(_self.selectedFilter === 3){
                return filteredShiftSchedule.filter((item) => {
                    return item.schedule.state === 'LOCKED'
                });
            }
            return filteredShiftSchedule;
        },
    },
    methods: {
        loadBudget: loadBudget,
        updateBudget: updateBudget,
        getSchedules: getSchedules,
        openSchedule: openSchedule,
        editSchedule: editSchedule,
        deleteSchedule: deleteSchedule,
        displayDate: displayDate,
        translateState: translateState,
        approveSchedule: approveSchedule,
        closeSchedule: closeSchedule,
        getItemDetails: getItemDetails,
        formatPhoneInfo: formatPhoneInfo,
        additionalCost: additionalCost,
        editScheduleItem: editScheduleItem,
        isSelectedFilter: isSelectedFilter,
        getChipClassFilter: getChipClassFilter,
        onSelectFilter: onSelectFilter,
        isSelectedFilterItem: isSelectedFilterItem,
        getChipClassFilterItem: getChipClassFilterItem,
        onSelectFilterItem: onSelectFilterItem,
        canTrainerOpenSchedule: canTrainerOpenSchedule,
        filterItemsInSchedule: filterItemsInSchedule,
        getChipClassFilterShift: getChipClassFilterShift,
        isSelectedFilterShift: isSelectedFilterShift,
        onSelectFilterShift: onSelectFilterShift,
        sortAllItems: sortAllItems,
        getItemLabel: getItemLabel,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        onUpdate(data, item) {
            item.showItems = data;
        },
        showProfit() {
            return (session.getUsername() === 'acoadmin' ) || session.getRole() === 'ROLE_SUPER_ADMIN';
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeCloseSchedule', () => {
            _self.scheduleToClose = null;
        });

        this.$topnavbar.$on('successCloseSchedule', () => {
            _self.scheduleToClose = null;
            this.getSchedules(true);
        });

        this.$topnavbar.$on('closeEditSchedule', () => {
            _self.scheduleToEdit = null;
        });

        this.$topnavbar.$on('successEditSchedule', () => {
            _self.scheduleToEdit = null;
            this.loadBudget();
            this.getSchedules(true);
        });

        this.$topnavbar.$on('closeCloseAddCostSchedule', () => {
            _self.additionalCostItem = null;
        });

        this.$topnavbar.$on('successCloseAddCostSchedule', () => {
            _self.additionalCostItem = null;
            this.getSchedules(true);
        });

        this.$topnavbar.$on('closeEditScheduleItem', () => {
            _self.scheduleItemToEdit = null;
        });

        this.$topnavbar.$on('successEditScheduleItem', () => {
            _self.scheduleItemToEdit = null;
            this.getSchedules(false);
        });



    },

    beforeMount() {
        this.role = session.getRole();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.loadBudget();
        this.getSchedules(true);
    }
}

function canTrainerOpenSchedule(){
    return this.schedules.filter(s => s.schedule.state === 'ACTIVE').length === 0
}

function additionalCost(item){
    this.additionalCostItem = item;
}

function getItemDetails(articleId) {
    let _self = this;
    AdminApiService.getArticleById(articleId)
        .then((response) => {
            let title = response.data.name;
            let message = _self.formatPhoneInfo(response.data);
                swal(title, message, 'success')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatPhoneInfo(data) {
    const formatDate = (timestamp) => {
        if (!timestamp) return "N/A";
        const date = new Date(timestamp * 1000);
        return date.toLocaleString("sr-RS", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return `
📱 Naziv: ${data.name}<br>
📦 Šifra: ${data.code}<br>
📂 Kategorija: ${data.mainCategory} ${data.subCategory}<br>
💶 Cena kupovine: ${data.purchasePrice} €<br>
📦 Na stanju: ${data.stockNumber}<br>
🕐 Datum kupovine: ${formatDate(data.buyDate)}<br>
🛠 Na servisu: ${data.onService ? "Da" : "Ne"}<br>
📤 Poslato poštom: ${data.sentByPost ? "Da" : "Ne"}<br>
👤 Promenio: ${data.changedBy}<br>
📋 Stanje: ${data.states}<br>
`.trim();
}

function loadBudget() {
    let _self = this;

    AdminApiService.getCurrentBudget()
        .then((response) => {
            this.currentEur = response.data.moneyEur;
            this.currentRsd = response.data.moneyRsd;
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function updateBudget() {
    let _self = this;

    let request = {
        moneyRsd: _self.newRsd,
        moneyEur: _self.newEur
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    AdminApiService.updateBudget(request)
        .then((response) => {
            _self.newRsd = 0;
            _self.newEur = 0;
            _self.editBalance = false;
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            _self.loadBudget();
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function openSchedule() {
    let _self = this;

    let request = {
        date: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        moneyRsdIn: _self.newScheduleRsd,
        moneyEurIn: _self.newScheduleEur
    }

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    AdminApiService.openSchedule(request)
        .then((response) => {
            _self.newScheduleRsd = 0;
            _self.newScheduleEur = 0;
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            _self.getSchedules();
            _self.loadBudget();
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getSchedules(showLoading) {
    let _self = this;
    _self.isLoading = showLoading
    let toDate = this.role.includes('ADMIN') ? _self.$moment(_self.toDate).format('DD-MM-YYYY') : _self.$moment(_self.fromDate).format('DD-MM-YYYY');
    var model = {
        fromDate: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate: toDate
    }

    AdminApiService.getSchedules(model)
        .then((response) => {
            let schedules = response.data;
            let schedulesNames = [];
            for (var i = 0; i < schedules.length; i++) {
                let schedule = schedules[i];
                var currentEur = 0;
                var currentRsd = 0;
                var profitEur = 0;
                if (!schedulesNames.includes(schedule.schedule.firstName)) {
                    schedulesNames.push(schedule.schedule.firstName);
                }
                for (var j = 0; j < schedule.items.length; j++) {
                    currentEur = currentEur + schedule.items[j].moneyEur;
                    currentRsd = currentRsd + schedule.items[j].moneyRsd;
                    profitEur = profitEur + (schedule.items[j].profitEur != null ? schedule.items[j].profitEur : 0);
                    schedule.items[j].itemLabel = _self.getItemLabel(schedule.items[j]);
                }
                if(schedules[i].schedule.state === 'ACTIVE' || schedules[i].schedule.profitEur == null){
                    schedules[i].schedule.profitEur = profitEur;
                }

                schedules[i].showItems = false;
                // OVDE SAM
                // schedules[i].filteredItems = schedule.items;
                schedules[i].filteredItems = _self.sortAllItems(schedule.items)
                schedules[i].data = []
                schedules[i].data.push({
                    id: 1,
                    size: schedule.items.length
                })
                schedules[i].data.push({
                    id: 2,
                    size: schedule.items.filter(i => (i.moneyRsd + (i.moneyEur * 117.5)) > 0 ).length
                })
                schedules[i].data.push({
                    id: 3,
                    size: schedule.items.filter(i => (i.moneyRsd + (i.moneyEur * 117.5)) < 0 && i.articleId != null).length
                })
                schedules[i].data.push({
                    id: 4,
                    size: schedule.items.filter(i => (i.moneyRsd === 0 && i.moneyEur === 0 && i.profitEur === 0 && i.profitRsd === 0 )).length
                })
                schedules[i].data.push({
                    id: 5,
                    size: schedule.items.filter(i => (i.articleId == null)).length
                })
                schedules[i].filterItems = 1;
                schedules[i].schedule.currentEur = currentEur;
                schedules[i].schedule.currentRsd = currentRsd;
            }
            _self.schedulesNames = schedulesNames;
            _self.schedules = schedules;
            _self.isLoading = false;
        })
        .catch((error) => {
            _self.isLoading = false;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function sortAllItems(items){
    return [... items].sort((a, b) => {
        // definisi prioritet grupe
        const getGroup = (i) => {
            const total = i.moneyRsd + (i.moneyEur * 117.5);
            if (total > 0 && i.articleId != null) return 1; // pozitivni
            if (total < 0 && i.articleId != null) return 2; // negativni
            if (i.articleId == null) return 3;              // bez artikla
            if (i.moneyRsd === 0 && i.moneyEur === 0 &&
                i.profitEur === 0 && i.profitRsd === 0 &&
                i.articleId != null
            ) return 4;                                     // nula vrednosti
            return 5; // ostalo
        };
        // return getGroup(a) - getGroup(b);

        const ga = getGroup(a);
        const gb = getGroup(b);
        if (ga !== gb) return ga - gb;                          // 1) po grupi
        return (a.timestamp) - (b.timestamp);

    });
}

function deleteSchedule(item) {
    if(!session.isMainAdmin()){
        swal(LocService.t('label_error'), LocService.t('label_not_permit_action'), 'error')
        return
    }
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_schedule_are_you_sure_to_delete'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteSchedule(item.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_success_delete_schedule'), 'success')
                _self.getSchedules(true)
                _self.loadBudget()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function displayDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function translateState(state) {
    switch (state) {
        case 'ACTIVE':
            return LocService.t('label_schedule_active')
        case 'CLOSED':
            return LocService.t('label_schedule_finished')
        case 'LOCKED':
            return LocService.t('label_schedule_lock')
        default:
            return state;
    }
}

function closeSchedule(item) {
    if(!session.isMainAdmin()){
        swal(LocService.t('label_error'), LocService.t('label_not_permit_action'), 'error')
        return
    }
    this.scheduleToClose = item
}

function approveSchedule(item, items) {
    if(!session.isMainAdmin()){
        swal(LocService.t('label_error'), LocService.t('label_not_permit_action'), 'error')
        return
    }
    let _self = this;
    console.log(items)
    let schedule = item;
    let currentEur = 0;
    let currentRsd = 0;
    for(var j = 0; j < items.length; j++){
        currentEur = currentEur + items[j].moneyEur;
        currentRsd = currentRsd + items[j].moneyRsd;
    }
    let moneyRsdOut = schedule.moneyRsdIn + currentRsd;
    let moneyEurOut = schedule.moneyEurIn + currentEur;

    let request = {
        moneyRsdOut: moneyRsdOut,
        moneyEurOut: moneyEurOut,
    }
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_schedule_are_you_sure_to_approve'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {
        });
        AdminApiService.approveSchedule(item.id, request)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_success_approved_schedule'), 'success')
                _self.getSchedules(true)
                _self.loadBudget()
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function editSchedule(item) {
    this.scheduleToEdit = item
}

function editScheduleItem(item) {
    this.scheduleItemToEdit = item
}

function getChipClassFilter(item){
    if(this.selectedFilter === item.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedFilter(item){
    return this.selectedFilter === item.id
}

function onSelectFilter(item){
    if(this.selectedFilter === item.id){
        this.selectedFilter = -1;
    }else{
        this.selectedFilter = item.id
    }
}

function getChipClassFilterItem(itemFilter, item){
    if(item.filterItems === itemFilter.id){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedFilterItem(itemFilter, item){
    return item.filterItems  === itemFilter.id
}

function onSelectFilterItem(itemFilter, item){
    if(item.filterItems === itemFilter.id){
        item.filterItems = 1;
    }else{
        item.filterItems = itemFilter.id
    }
    this.filterItemsInSchedule(item)
}

function filterItemsInSchedule(item){
    let items = this.sortAllItems(item.items)
    let filterItems = item.filterItems;
    if(filterItems === 1){
        item.filteredItems = items;
    }else if(filterItems === 2){
        item.filteredItems = items
            .filter(i => (i.moneyRsd + (i.moneyEur * 117.5)) > 0 && i.articleId != null)
            .sort((a, b) => a.timestamp - b.timestamp)
    }else if(filterItems === 3){
        item.filteredItems = items
            .filter(i => (i.moneyRsd + (i.moneyEur * 117.5)) < 0 && i.articleId != null)
            .sort((a, b) => a.timestamp - b.timestamp)
    }else if(filterItems === 4){
        item.filteredItems = items
            .filter(i => (i.moneyRsd === 0 && i.moneyEur === 0 && i.profitEur === 0 && i.profitRsd === 0 && i.articleId != null))
            .sort((a, b) => a.timestamp - b.timestamp)
    }else if(filterItems === 5){
        item.filteredItems = items
            .filter(i => (i.articleId == null))
            .sort((a, b) => a.timestamp - b.timestamp)
    } else{
        item.filteredItems = items;
    }
}

function getItemLabel(item){
    const total = item.moneyRsd + (item.moneyEur * 117.5);

    if (total > 0 && item.articleId != null) {
        return LocService.t('label_si_sell'); // prihod
    }
    if (total < 0 && item.articleId != null) {
        return LocService.t('label_si_buy'); // rashod
    }
    if (
        item.moneyRsd === 0 && item.moneyEur === 0 &&
        item.profitEur === 0 && item.profitRsd === 0 &&
        item.articleId != null
    ) {
        return LocService.t('label_si_purchase'); // nulta vrednost
    }
    if (item.articleId == null) {
        return LocService.t('label_si_additional_cost');
    }

    return "";
}

function getChipClassFilterShift(item){
    if(this.selectedShiftName === item){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedFilterShift(item){
    return this.selectedShiftName === item
}

function onSelectFilterShift(item){
    if(this.selectedShiftName === item){
        this.selectedShiftName = "";
    }else{
        this.selectedShiftName = item
    }
}


// WEBPACK FOOTER //
// ./src/components/CSchedule/CSchedule.js